<template>
  <b-container>
    <h1>Log in</h1>
    <b-form @submit.prevent="pressed">
      <b-form-group
        id="input-group-1"
        label=""
        label-align="left"
        label-for="input-1"
        description=""
      >
        <b-form-input
          id="input-1"
          v-model="form.email"
          type="email"
          required
          placeholder="Enter email"
        ></b-form-input>
      </b-form-group>
      <b-form-group
        id="input-group-2"
        label=""
        label-align="left"
        label-for="input-2"
        description=""
      >
        <b-form-input
          id="input-2"
          v-model="form.password"
          type="password"
          required
          placeholder="Enter password"
        ></b-form-input>
      </b-form-group>
      <b-button type="submit" variant="primary">Submit</b-button>
    </b-form>
    <div class="error" v-if="error">{{ error.message }}</div>
  </b-container>
</template>

<script>
import * as firebase from 'firebase/app';
import 'firebase/auth';

export default {
  data() {
    return {
      form: {
        email: '',
        password: '',
      },
      error: '',
    };
  },
  methods: {
    pressed() {
      firebase
        .auth()
        .signInWithEmailAndPassword(this.form.email, this.form.password)
        .then((data) => {
          console.log(data);
          this.$router.replace({ name: 'sessions' });
        })
        .catch((err) => {
          this.error = err;
          // console.log('Error logging the user');
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.error {
  color: red;
  font-size: 18px;
}

h1 {
  margin: 20px;
}
</style>
